import { Clock } from 'three';
import { camera } from './scene';
import { composer } from './render';
import { updateRaycaster } from './raycaster';

type UpdateFunction = (delta: number, elapsedTime: number) => void;
const updateFunctions: UpdateFunction[] = [
  camera.update,
];

const clock = new Clock(true);
function animate() {
  composer.render();
  updateRaycaster(camera);

  // delta is time elapsed in seconds
  const delta = clock.getDelta();
  const elapsedTime = clock.elapsedTime;
  updateFunctions.forEach((updateFunction) => {
    updateFunction(delta, elapsedTime);
  });

  requestAnimationFrame( animate );
};

requestAnimationFrame( animate );

export function addToRenderLoop(updateFunction: UpdateFunction): void {
  updateFunctions.push(updateFunction);
}

window.addEventListener('blur', () => {
  clock.stop();
});

window.addEventListener('focus', () => {
  clock.start();
});
